import type { User } from "firebase/auth";
import { mountDungeonFloorPage } from "@/pages/dungeon-floor-page";
import { openDungeonModal } from "@/mount-dungeon-modal";

let activeTeardown: (() => void) | null = null;
let activeOverlay: HTMLElement | null = null;

export type OpenDungeonFloorModalOptions = {
  /** After close, reopen dungeon lobby on home. */
  returnToDungeonLobby?: boolean;
};

/** Floor editor overlay on home (not a separate app route). */
export async function openDungeonFloorModal(
  user: User,
  floor: number,
  options?: OpenDungeonFloorModalOptions,
): Promise<() => void> {
  activeTeardown?.();
  activeTeardown = null;
  activeOverlay?.remove();
  activeOverlay = null;

  const overlay = document.createElement("div");
  overlay.className = "tower-modal dungeon-floor-modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", `แก้ไขด่าน ${floor}`);

  const backdrop = document.createElement("button");
  backdrop.type = "button";
  backdrop.className = "tower-modal-backdrop";
  backdrop.setAttribute("aria-label", "ปิด");

  const shell = document.createElement("div");
  shell.className = "tower-modal-shell dungeon-floor-modal-shell";
  overlay.append(backdrop, shell);
  document.body.appendChild(overlay);
  document.body.classList.add("has-tower-modal");

  let pageTeardown: (() => void) | null = null;

  const close = () => {
    pageTeardown?.();
    pageTeardown = null;
    overlay.remove();
    activeOverlay = null;
    activeTeardown = null;
    document.body.classList.remove("has-tower-modal");
    window.removeEventListener("keydown", onKeyDown);
    if (options?.returnToDungeonLobby) {
      void openDungeonModal(user);
    }
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") close();
  };
  window.addEventListener("keydown", onKeyDown);

  pageTeardown = await mountDungeonFloorPage(shell, user, floor, {
    onRequestClose: close,
  });
  activeTeardown = pageTeardown;
  activeOverlay = overlay;

  return close;
}
